import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      if (!sessionId) return setStatus("error");
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refresh();
          return setStatus("paid");
        }
        if (["expired", "failed"].includes(data.payment_status)) return setStatus("error");
      } catch {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("error");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] p-6">
      <div className="bg-white rounded-3xl p-12 shadow-sm border border-slate-100 text-center max-w-md" data-testid="payment-success">
        {status === "checking" && (<><Loader2 size={56} className="animate-spin text-sky-500 mx-auto" /><h1 className="font-heading text-2xl font-black text-slate-900 mt-6">Потвърждаване на плащането...</h1></>)}
        {status === "paid" && (<>
          <CheckCircle2 size={56} className="text-emerald-500 mx-auto" />
          <h1 className="font-heading text-3xl font-black text-slate-900 mt-6">Благодарим! 🎉</h1>
          <p className="text-slate-500 mt-2">Абонаментът ви е активен. Вече имате неограничен достъп до AI генераторите.</p>
          <button data-testid="go-dashboard-btn" onClick={() => navigate("/app")} className="mt-8 bg-sky-500 hover:bg-sky-600 text-white font-bold px-8 py-3 rounded-full transition-colors">Към таблото</button>
        </>)}
        {status === "error" && (<>
          <XCircle size={56} className="text-red-400 mx-auto" />
          <h1 className="font-heading text-2xl font-black text-slate-900 mt-6">Нещо се обърка</h1>
          <p className="text-slate-500 mt-2">Плащането не бе потвърдено. Опитайте отново.</p>
          <button onClick={() => navigate("/app/pricing")} className="mt-8 bg-slate-900 text-white font-bold px-8 py-3 rounded-full">Обратно към плановете</button>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] p-6">
      <div className="bg-white rounded-3xl p-12 shadow-sm border border-slate-100 text-center max-w-md" data-testid="payment-cancel">
        <XCircle size={56} className="text-amber-400 mx-auto" />
        <h1 className="font-heading text-2xl font-black text-slate-900 mt-6">Плащането е отказано</h1>
        <p className="text-slate-500 mt-2">Не е направено плащане. Можете да опитате отново когато сте готови.</p>
        <button onClick={() => navigate("/app/pricing")} className="mt-8 bg-sky-500 hover:bg-sky-600 text-white font-bold px-8 py-3 rounded-full transition-colors">Обратно към плановете</button>
      </div>
    </div>
  );
}
